import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { LittleSubHeadline, NotificationText, SubTitle } from "../../../../components/typography";
import { TitleSpan, FixedBodyDiv } from "../team/view-team";
import { StyledTab, TabList, Underline } from "../../../finance/main";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { basketItems } from "../../../../assets/utils/enums/basket";

export type LoaderOutletContext = {
    setLoaderState: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function BasketSettingsTab() {
    const { setLoaderState } =
        useOutletContext<LoaderOutletContext>();
    const location = useLocation();
    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV}`}
            $isPadding={true}
        >
            <TitleSpan>
                <SubTitle>Кошик</SubTitle>
                <NotificationText>Відновлення нещодавно видалених об'єктів.</NotificationText>
            </TitleSpan>

            <TabList key="tabs-basket" className="flex-grow-0 w-100 justify-content-between">
                {basketItems.map((item) =>
                    <StyledTab
                        to={item.id}
                        key={item.id}
                        className={`p-0 ${(isActive: boolean) => (isActive ? "active" : "")}`}
                        $color={COLORS.blue}
                    >
                        <LittleSubHeadline>{item.value}</LittleSubHeadline>
                        {location.pathname === `/settings/basket/${item.id}` && (
                            <Underline $color={COLORS.blue} layoutId="underline" />
                        )}
                    </StyledTab>)}
                  
            </TabList>

            <Outlet context={{setLoaderState}} />
        </FixedBodyDiv>
    )
}